import { IAssetCartRequestShortView } from '@interfaces/rent/assetRent';

export const prepareAssetCartRequestList = (
	assetCartRequestList: {
		page: { items: Array<IAssetCartRequestShortView> };
	}[]) => {
	return assetCartRequestList.reduce((acc, currentValue) => {
		return acc.concat(currentValue.page.items as any);
	}, []);
};
